import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreContactDetails } from 'src/app/core/interfaces/store-configuration.interface';
import { ContactInfoPanelConfiguration } from 'src/app/home/components/dynamic-home-page/dynamic-home-page.component';

@Component({
  selector: 'webstore-contact-info-panel',
  templateUrl: './contact-info-panel.component.html',
  styleUrls: ['./contact-info-panel.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class ContactInfoPanelComponent {
  readonly contactInfoPanelConfiguration = input<ContactInfoPanelConfiguration>();
  readonly storeContactDetails = input<StoreContactDetails>();
}

